module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_02-93493bcfa8f128fc5159548891953533.webp";